import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Tag } from 'antd';
import type { IInfaktSyncTagProps } from 'components/invoices/infakt-sync-tag/types';

export const InfaktSyncTag: React.FC<IInfaktSyncTagProps> = (props) => {
  const { status } = props;
  const { t } = useTranslation('invoice');

  const { color, label } = useMemo(() => {
    switch (status) {
      case 'synced':
        return { color: 'green', label: t('infakt_status_synced') };
      case 'sync_failed':
        return { color: 'red', label: t('infakt_status_sync_failed') };
      case 'pending':
        return { color: 'default', label: t('infakt_status_pending') };
      case 'sent':
        return { color: 'default', label: t('infakt_status_sent') };
      default:
        return { color: 'default', label: t('infakt_status_not_sent') };
    }
  }, [status]);

  return <Tag color={color}>{label}</Tag>;
};
